
export const getDaysDifference = (publishedOn) => {
  
    const pubDate= new Date(publishedOn?.split("T",1));
    const today = new Date();
    const todayDate = new Date(today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate());
    const diff = Math.abs(pubDate - todayDate);
      return getMessageByDiffInTime(diff); 
  
  }
  
  const getMessageByDiffInTime = (diff) => {
  
    const diffInDays= Math.floor(diff / (1000 * 60 * 60 * 24));
     
    const diffInWeeks= Math.floor(diff / (1000 * 60 * 60 * 24 * 7));
   // const diffInMonths = Math.floor(diffInWeeks/4);
   
    const diffInYear = Math.floor(diffInDays/365);
  if(diffInDays < 1)
  {
    return "Today";
  }
  else if(diffInDays <= 30)
  {
    if(diffInDays < 7 && diffInDays > 1)
    {
      return diffInDays + " days ago";
    }
    else if(diffInDays == 1)
    {
      return diffInDays + " day ago";
    }
    else if(diffInDays >= 7 && diffInDays < 14 )
    {
        return diffInWeeks + " week ago";
    }
    else if(diffInDays >=7 && diffInDays <=30)
    {
      return diffInWeeks + " weeks ago";
    }
  }
  else if(diffInDays>=31 && diffInDays < 365)
  {
   return getDiffInMonths(diffInDays)
  }
  else if(diffInDays>=365)
  {
    if(diffInDays === 365)
    {
        return diffInYear + ' year ago';
    } else {
        
        const additionalDays = diffInDays - (diffInYear * 365);
      let monthsValue = getDiffInMonths(additionalDays);
      monthsValue =  monthsValue === '0 month ago' ? 'ago' : monthsValue;
      const yearSingularPlural = diffInYear === 1 ? 'year' : 'years';
        return diffInYear + ' ' + yearSingularPlural + ' ' + monthsValue;
    }
  }
  }
  
  const getDiffInMonths = (diffInDays) => {
  const diffInMonths = Math.floor(diffInDays/30);
   if(diffInMonths > 1)
    {
      return diffInMonths + " months ago";
    }
    else if(diffInMonths<=1)
    {
      return diffInMonths + " month ago";
    }
  }